import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 40000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (!config.headers) config.headers = {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      setTimeout(() => {
        // window.location.href = "/login";
      }, 3000);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.log("err--", error);

    const message = error.response?.data?.message;
    console.log("message", message);

    if (message === "Forbidden: Invalid token") {
      localStorage.removeItem("authToken");
      localStorage.removeItem("persist:root");
      window.location.href = "/login";
    }

    if (message === "Unauthorized: No token provided") {
      console.error("Unauthorized access - clearing Redux and redirecting...");
      localStorage.removeItem("authToken");
      localStorage.removeItem("persist:root");

      try {
        const storeModule = await import("../redux/store"); // adjust path if needed
        const authModule = await import("../redux/slices/authSlice");

        const { store, persistor } = storeModule;
        const { logout } = authModule;

        // Reset Redux state
        store.dispatch(logout());

        // Purge redux-persist state
        await persistor.purge();

        // Forcefully remove persist:root from localStorage
        localStorage.removeItem("persist:root");

        // Optional: notify user
        // toast.error("Session expired. Redirecting to login...");
      } catch (err) {
        console.error("Error during logout and state purge:", err);
      }

      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
